<template>
  <div class="home">
    <CinemaForm/>
  </div>
</template>

<script>
// @ is an alias to /src
import CinemaForm from '@/components/CinemaForm'

export default {
  name: 'Home',
  components: {
    CinemaForm
  }
}
</script>
